import { DaoModel } from '@dynameat/models';
import { SubsectionRecommendation } from './subsectionRecommendation';
import { ProductRecommendation } from './productRecommendation';
import { MenuProductChange } from './menuProductChange';

export class ServiceRecommendation extends DaoModel {
  constructor(guid, subsections, products) {
    super(guid);
    this.subsections = subsections || [];
    this.products = products || [];
  }

  static toInstance(props = {}) {
    const subsections = SubsectionRecommendation.toInstanceList(props.subsections);
    const products = ProductRecommendation.toInstanceList(props.products);
    return new ServiceRecommendation(props.guid, subsections, products);
  }

  serialize() {
    return {
      ...super.serialize(),
      subsections: this.subsections.map((subsection) => subsection.serialize()),
      products: this.products.map((product) => product.serialize())
    };
  }

  get totalItems() {
    return this.subsections.flatMap((el) => el.products).length + this.products.length;
  }

  hasChange() {
    return this.products.some((p) => p.hasChange()) || this.subsections.some((ss) => ss.hasChange());
  }

  getVisibleProductsLength() {
    const subsectionVisibleProductLength = this.subsections.reduce((total, subsection) => total + subsection.getVisibleProductsLength(), 0);
    const serviceVisibleProductsLength = this.products.filter((p) => p.is_visible).length;
    return subsectionVisibleProductLength + serviceVisibleProductsLength;
  }

  getChanges(groupCodeName) {
    // Extract subsection changes
    const subsectionChanges = this.subsections.flatMap((subsection) => subsection.getChanges(this.guid, groupCodeName));
    // Extract product changes
    const productChanges = this.products.reduce((changes, product) => {
      if (product.hasChange()) {
        changes.push(new MenuProductChange(product.guid, this.guid, groupCodeName, product.order, product.is_visible, product.special, product.special_frame));
      }
      return changes;
    }, []);
    return [...subsectionChanges, ...productChanges];
  }
}
